import React, { Component } from "react";
import { Switch, Route, Link } from 'react-router-dom'
import { connect } from 'react-redux';
import {
	Alert,
	Navbar,
	NavbarBrand,
	Nav,
	NavItem,
	NavLink,
	Popover,
	PopoverBody,
	Badge
} from 'reactstrap';

import MaterialIcon from 'material-icons-react';
import { GridLoader } from 'react-spinners';
import i18n from '../i18next';

import PageNotFoundScreen from './PageNotFoundScreen';
import BrandScreen from './brands/BrandScreen';
import BrandsScreen from './brands/BrandsScreen';
import AdminsScreen from './users/AdminsScreen';
import RestaurantsScreen from './restaurants/RestaurantsScreen';
import ProfileScreen from './users/ProfileScreen';
import JobHistoryScreen from './jobhistory/JobHistoryScreen';
import CentralOrdersLogScreen from './central/CentralOrdersLogScreen';

import { MESSAGE_LEVEL_SUCCESS, languageList } from '../utils/Constants';
import { userRestrictions } from '../utils/CommonUtils';

import { loadUserFromLocalStorage, loadNotifications, logout, clearMessage, changeLanguage } from '../actions';
import RestaurantMainContainer from "./restaurants/RestaurantMainContainer";
import Notifications from "./Notifications";
import SystemControlContainer from './systemControl/SystemControlContainer';
// import ConnectWithStripePage from "./restaurants/ConnectWithStripePage";
import CreateTicketScreen from "./support/CreateTicketScreen";
import { MENUU_ADMIN, MENUU_MASTER_ADMIN, CHAIN_ADMIN } from '../utils/Constants';
import ReactCountryFlag from 'react-country-flag';
import MenuuLogoSVG from "../images/MenuuLogoSVG";
import EventTrackingScreen from "./eventTracking/EventTrackingScreen";
import { Button } from "reactstrap";
import BillingDashboard from "./restaurants/settings/restaurant/menuuBilling/BillingDashboard";

class MainContainer extends Component {
	constructor(props) {
		super(props);

		this.toggleProfilePopover = this.toggleProfilePopover.bind(this);
		this.toggleNotificationsPopover = this.toggleNotificationsPopover.bind(this);
		this.toggleDashboardPopover = this.toggleDashboardPopover.bind(this);
		this.logout = this.logout.bind(this);
		this.editProfile = this.editProfile.bind(this);
		this.toggleLanguagePopover = this.toggleLanguagePopover.bind(this);

		this.state = {
			profilePopoverOpen: false,
			notificationPopoverOpen: false,
			dashboardPopoverOpen: false,
			importPublishNotificationTimer: null,
			languagePopoverOpen: false
		};
	}

	notifications = 0;

	componentWillMount() {
		// If user is already logged in from previous usage
		// then load data from local storage to redux store
		if (localStorage.getItem('token') !== undefined && localStorage.getItem('token') !== null &&
			(this.props.currentlyLoggedInUser.token === undefined || this.props.currentlyLoggedInUser.token === null ||
				this.props.currentlyLoggedInUser.token === '')) {

			this.props.loadUserFromLocalStorage();
		}

		let that = this;

		this.props.loadNotifications(this.props.restaurant.id);

		this.notifications = setInterval(() => {
			that.props.loadNotifications(that.props.restaurant.id);
		}, 120000);
	}

	componentWillUnmount() {
		clearInterval(this.notifications);
	}

	manageImportPublishNotificationTimer() {
		if ((this.props.importInProgress || this.props.publishInProgress) && this.state.importPublishNotificationTimer == null) {
			this.state.importPublishNotificationTimer = setInterval(() => {
				this.props.loadNotifications(this.props.restaurant.id);
			}, 15000)
		} else if (!this.props.importInProgress && !this.props.publishInProgress && this.state.importPublishNotificationTimer !== null) {
			clearInterval(this.state.importPublishNotificationTimer);

			this.setState({
				...this.state,
				importPublishNotificationTimer: null
			})
		}
	}

	toggleProfilePopover() {
		this.setState({
			profilePopoverOpen: !this.state.profilePopoverOpen
		});
	}

	toggleNotificationsPopover() {
		this.setState({
			notificationPopoverOpen: !this.state.notificationPopoverOpen,
			selectedNotificationFilter: ''
		});
	}


	toggleDashboardPopover() {
		this.setState({
			dashboardPopoverOpen: !this.state.dashboardPopoverOpen,
			selectedNotificationFilter: ''
		});
	}

	toggleLanguagePopover() {
		this.setState({
			languagePopoverOpen: !this.state.languagePopoverOpen
		});
	}

	logout() {
		let that = this;
		this.props.logout();
		let myInterval = setInterval(function () {
			that.props.loadNotifications(that.props.restaurant.id);
		}, 120000);
		clearInterval(myInterval);
	}

	editProfile() {
		this.toggleProfilePopover();
		this.props.history.push('/profile');
	}

	renderProfilePopover() {
		const { popoverLogout, popoverCurrentUser, currentUserSpan, cursorPointer } = styles;

		return (
			<Popover placement="bottom" isOpen={this.state.profilePopoverOpen} target="userProfile" toggle={this.toggleProfilePopover}>
				<PopoverBody>
					<p style={popoverCurrentUser} onClick={this.editProfile}>
						{this.props.currentlyLoggedInUser.name}
						<span style={currentUserSpan}><MaterialIcon icon="edit" size={20} color="#0288d1" /></span>
					</p>
					<p style={cursorPointer}>{i18n.t('common:T&Cs.title')}</p>
					<p style={popoverLogout} onClick={this.logout}>{i18n.t('screens:mainContainer.logout')} &nbsp;<MaterialIcon icon="exit_to_app" size={20} color="#0288d1" /></p>
				</PopoverBody>
			</Popover>
		);
	}

	changeLanguage = (language) => {
		this.props.changeLanguage(language);
		this.toggleLanguagePopover();
		window.location.reload();
	}

	renderLanguagePopover() {
		return (
			<Popover placement="bottom" isOpen={this.state.languagePopoverOpen} target="userLanguage" toggle={this.toggleLanguagePopover}>
				<PopoverBody>
					{languageList.map((language, i) => {
						if (i + 1 === languageList.length) {
							return (
								<Button color='primary' style={{ height: '38px' }} onClick={() => this.changeLanguage(language.toLowerCase())}>
									<span>{language === 'GB' ? 'EN' : language}</span>
								</Button>
							)
						} else {
							return (
								<Button color='primary' style={{ borderRight: '1px solid #FFF', height: '38px' }} onClick={() => this.changeLanguage(language.toLowerCase())}>
									<span>{language === 'GB' ? 'EN' : language}</span>
								</Button>
							)
						}
					})}
				</PopoverBody>
			</Popover>
		);
	}

	renderNotificationPopover() {
		const { notificationPopover } = styles

		return (
			<Popover style={notificationPopover} placement="bottom" isOpen={this.state.notificationPopoverOpen} target="userNotifications" toggle={this.toggleNotificationsPopover}>
				<PopoverBody>
					<Notifications onToggle={this.toggleNotificationsPopover} />
				</PopoverBody>
			</Popover>
		);
	}

	renderDashboardPopover() {
		const { currentlyLoggedInUser } = this.props;

		const userRoleRestrictions = userRestrictions(currentlyLoggedInUser.role);
		const brandsColor = ((this.props.location.pathname == '/brands' || this.props.location.pathname.includes("brand")) ? '#0288d1' : '#757575');
		const restaurantsColor = ((this.props.location.pathname == '/restaurants' || this.props.location.pathname.includes("restaurant")) ? '#0288d1' : '#757575');
		const jobsColor = ((this.props.location.pathname == '/job-history') ? '#0288d1' : '#757575');

		return (
			<Popover id="dashboard-popover" placement="bottom" isOpen={this.state.dashboardPopoverOpen} target="dashboard" toggle={this.toggleDashboardPopover}>
				<PopoverBody id="dashboard-popover-body">
					<NavLink hidden={userRoleRestrictions} tag={Link} to="/brands" onClick={this.toggleDashboardPopover}>
						<span className="navMenuIcons"><MaterialIcon icon="star" size={24} color={brandsColor} /></span>
						<span style={{ color: brandsColor }}>{i18n.t('screens:restaurantsMainContainer.brands')}</span>
					</NavLink>
					<NavLink tag={Link} to="/restaurants" onClick={this.toggleDashboardPopover}>
						<span className="navMenuIcons"><MaterialIcon icon="restaurant_menu" size={24} color={restaurantsColor} /></span>
						<span style={{ color: restaurantsColor }}>{i18n.t('screens:restaurantsMainContainer.restaurants')}</span>
					</NavLink>
					<NavLink hidden={userRoleRestrictions} tag={Link} to="/job-history" onClick={this.toggleDashboardPopover}>
						<span className="navMenuIcons"><MaterialIcon icon="list_alt" size={24} color={jobsColor} /></span>
						<span style={{ color: jobsColor }}>{i18n.t('screens:restaurantsMainContainer.jobs')}</span>
					</NavLink>
				</PopoverBody>
			</Popover>
		);
	}

	renderLoadingContainer() {
		const { loadingIndicator, loadingContainerTransparent } = styles;

		if (this.props.loading) {
			return (
				<div style={loadingContainerTransparent}>
                    <div style={loadingIndicator} className='text-center loadingIndicator'>
                        <GridLoader color="#0288d1" size={20} />
                    </div>
                </div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

	renderMessage() {
		if (this.props.message.text !== undefined && this.props.message.text !== null && this.props.message.text !== '') {

			const successMessage = (this.props.message.level === MESSAGE_LEVEL_SUCCESS);

			if (successMessage) {
				setTimeout(() => {
					this.props.clearMessage();
				}, 3000);
			}

			const color = successMessage ? 'success' : 'danger';
			const dismiss = successMessage ? null : this.props.clearMessage.bind(this);

			const { alertStyle } = styles;

			return (
				<div style={alertStyle}>
					<Alert color={color} toggle={dismiss}>
						{this.props.message.text}
					</Alert>
				</div>
			);
		} else {
			return (
				<div></div>
			);
		}
	}

	renderNotificationCounter() {
		const { notifications } = this.props;
		const { badgeStyle } = styles;

		if (notifications !== undefined && notifications !== null && notifications.length > 0) {
			return (
				<span style={badgeStyle}>
					<Badge color="warning">{notifications.length}</Badge>
				</span>
			)
		}
	}

	userRestrictionOrdersButton(role) {
		if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN || role === CHAIN_ADMIN) {
			return false;
		}

		return true;
	}

	isUserDifferentFromMadminOrAdmin(role) {
		if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
			return false;
		}

		return true;
	}

	isUserDifferentFromMadmin(role) {
		if (role === MENUU_MASTER_ADMIN || role === MENUU_ADMIN) {
			return false;
		}

		return true;
	}

	isUserDifferentFromMasteradmin(role) {
		if (role === MENUU_MASTER_ADMIN) {
			return false;
		}

		return true;
	}


	render() {
		const { currentlyLoggedInUser } = this.props;
		const { mainContainer, cursorPointer, notificationStyle, navBarStyle, separator, dashboardDivStyle,
			supportLinkStyle, notificationNavItem, profileNavItem, logoSvg } = styles;

		const userRoleRestrictions = userRestrictions(currentlyLoggedInUser.role);
		const isShowOrders = this.userRestrictionOrdersButton(currentlyLoggedInUser.role);
		// const dashboardColor = ((this.props.location.pathname == '/brands' || this.props.location.pathname == '/restaurants'
		// 	|| this.props.location.pathname == '/job-history' || this.props.location.pathname.includes("restaurant")
		// 	|| this.props.location.pathname.includes("brand")) ? '#0288d1' : '#757575');
		const supportColor = ((this.props.location.pathname == '/support') ? '#0288d1' : '#757575');
		const usersColor = ((this.props.location.pathname == '/admins') ? '#0288d1' : '#757575');
		const profileColor = ((this.props.location.pathname == '/profile') ? '#0288d1' : '#757575');

		const systemColor = ((this.props.location.pathname == '/system-control' || this.props.location.pathname.includes("system-control")) ? '#0288d1' : '#757575');
		const brandsColor = ((this.props.location.pathname == '/brands' || this.props.location.pathname.includes("brand")) ? '#0288d1' : '#757575');
		const ordersColor = ((this.props.location.pathname == '/orders-log' || this.props.location.pathname.includes("orders-log")) ? '#0288d1' : '#757575');
		const restaurantsColor = ((this.props.location.pathname == '/restaurants' || this.props.location.pathname.includes("restaurant")) ? '#0288d1' : '#757575');
		const jobsColor = ((this.props.location.pathname == '/job-history') ? '#0288d1' : '#757575');
		const eventTrackingColor = ((this.props.location.pathname == '/event-tracking') ? '#0288d1' : '#757575');
		const billingDashboardColor = ((this.props.location.pathname == '/billing-dashboard') ? '#0288d1' : '#757575');

		this.manageImportPublishNotificationTimer();

		return (
			<div style={mainContainer}>
				<Navbar style={navBarStyle} light expand="md">
					<NavbarBrand tag={Link} to="/restaurants">
						<span style={logoSvg}><MenuuLogoSVG width={150} height={38} fill={'#000'} /></span>
					</NavbarBrand>
					<Nav className="ml-auto" navbar>
						<div style={dashboardDivStyle}>
							{/* <NavItem style={{marginRight: 20, color:dashboardColor}} id="dashboard" onClick={this.toggleDashboardPopover} >
                                <span style={dashboardSpanIcon}>
                                    <MaterialIcon icon="store" size={32} color={dashboardColor} />
                                </span>
                                <p style={dashboardText}>{i18n.t('screens:mainContainer.dashboard')}</p>
                                {this.renderDashboardPopover()}
							</NavItem> */}
							<NavLink hidden={isShowOrders} tag={Link} to="/orders-log" style={supportLinkStyle}>
								<MaterialIcon icon="shopping_cart" size={32} color={ordersColor} />
								<p style={{ fontSize: 14, marginBottom: 0, color: ordersColor }}>
									{i18n.t('screens:restaurantsMainContainer.orders')}
								</p>
							</NavLink>
							<NavLink hidden={userRoleRestrictions} tag={Link} to="/brands" style={supportLinkStyle}>
								<MaterialIcon icon="star" size={32} color={brandsColor} />
								<p style={{ fontSize: 14, marginBottom: 0, color: brandsColor }}>
									{i18n.t('screens:restaurantsMainContainer.brands')}
								</p>
							</NavLink>
							<NavLink tag={Link} to="/restaurants" style={supportLinkStyle}>
								<MaterialIcon icon="restaurant_menu" size={32} color={restaurantsColor} />
								<p style={{ fontSize: 14, marginBottom: 0, color: restaurantsColor }}>
									{i18n.t('screens:restaurantsMainContainer.restaurants')}
								</p>
							</NavLink>
							<NavLink hidden={userRoleRestrictions} tag={Link} to="/job-history" style={supportLinkStyle}>
								<MaterialIcon icon="list_alt" size={32} color={jobsColor} />
								<p style={{ fontSize: 14, marginBottom: 0, color: jobsColor }}>
									{i18n.t('screens:restaurantsMainContainer.jobs')}
								</p>
							</NavLink>
							<NavLink hidden={this.isUserDifferentFromMadmin(currentlyLoggedInUser.role)} tag={Link} to="/event-tracking" style={supportLinkStyle}>
								<MaterialIcon icon="event_note" size={32} color={eventTrackingColor} />
									<p style={{ fontSize: 14, marginBottom: 0, color: eventTrackingColor }}>
										{i18n.t('screens:restaurantsMainContainer.eventTracking')}
									</p>
							</NavLink>
							<NavLink hidden={this.isUserDifferentFromMasteradmin(currentlyLoggedInUser.role)} tag={Link} to="/billing-dashboard" style={supportLinkStyle}>
								<MaterialIcon icon="attach_money" size={32} color={billingDashboardColor} />
									<p style={{ fontSize: 14, marginBottom: 0, color: billingDashboardColor }}>
										{i18n.t('screens:restaurantsMainContainer.billing')}
									</p>
							</NavLink>

							<NavLink style={supportLinkStyle} tag={Link} to="/support">
								<MaterialIcon icon="headset_mic" size={32} color={supportColor} />
								<p style={{ fontSize: 14, marginBottom: 0, color: supportColor }}>{i18n.t('screens:restaurantsMainContainer.support')}</p>
							</NavLink>
							<NavLink style={supportLinkStyle} hidden={currentlyLoggedInUser.role === "CHAIN_MANAGER" || currentlyLoggedInUser.role === "CHAIN_ADMIN" ? true : userRoleRestrictions} tag={Link} to="/admins">
								<MaterialIcon icon="group" size={32} color={usersColor} />
								<span style={{ display: 'flex', color: usersColor }}>{i18n.t('screens:restaurantsMainContainer.users')}</span>
							</NavLink>
							<NavLink
								hidden={this.isUserDifferentFromMadminOrAdmin(currentlyLoggedInUser.role)}
								tag={Link}
								to='/system-control/restrictions'
								style={supportLinkStyle}>
								<MaterialIcon icon="settings" size={32} color={systemColor} />
								<p style={{ fontSize: 14, marginBottom: 0, color: systemColor }}>
									{i18n.t('screens:restaurantsMainContainer.system')}
								</p>
							</NavLink>
						</div>
						<span style={separator}>|</span>
						<NavItem style={notificationNavItem}>
							<div onClick={this.toggleNotificationsPopover}>
								{this.renderNotificationCounter()}
								<div id="userNotifications" style={notificationStyle}>
									<MaterialIcon icon="notifications" size={28} />
								</div>
								{this.renderNotificationPopover()}
							</div>
						</NavItem>
						<NavItem style={profileNavItem}>
							<div>
								<div id="userProfile" onClick={this.toggleProfilePopover} style={cursorPointer}>
									<MaterialIcon icon="account_circle" size={36} color={profileColor} />
								</div>
								{this.renderProfilePopover()}
							</div>
						</NavItem>
						<NavItem style={{ ...profileNavItem, marginLeft: 9 }}>
							<div>
								<div id="userLanguage" onClick={this.toggleLanguagePopover} style={cursorPointer}>
									<Button color='primary' style={{ height: '38px' }}>
										<span>{this.props.language === 'gb' ? 'EN' : this.props.language.toUpperCase()}</span>
									</Button>
								</div>
								{this.renderLanguagePopover()}
							</div>
						</NavItem>
					</Nav>
				</Navbar>
				<div>
					<Switch>
						<Route path='/system-control' component={SystemControlContainer} />
						<Route path='/brand/:id' component={BrandScreen} />
						<Route path='/orders-log' component={CentralOrdersLogScreen} />
						<Route path='/restaurants' component={RestaurantsScreen} />
						<Route path='/admins' component={AdminsScreen} />
						<Route path='/support' component={CreateTicketScreen} />
						<Route path='/profile' component={ProfileScreen} />
						<Route path='/restaurant/:id/:section' component={RestaurantMainContainer} />
						<Route path='/brands' component={BrandsScreen} />
						<Route path='/job-history' component={JobHistoryScreen} />
						<Route path='/event-tracking' component={EventTrackingScreen} />
						<Route path='/billing-dashboard' component={BillingDashboard} />
						{/* <Route path='/stripe/connect' component={ConnectWithStripePage} /> */}
						<Route component={PageNotFoundScreen} />
						<Route path='/page-not-found' component={PageNotFoundScreen} />
					</Switch>
				</div>
				{this.renderLoadingContainer()}
				{this.renderMessage()}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		currentlyLoggedInUser: state.user,
		notifications: state.notifications,
		importInProgress: state.importInProgress,
		publishInProgress: state.publishInProgress,
		loading: state.loading,
		message: state.message,
		restaurant: state.restaurant,
		language: state.language.language
	};
};

export default connect(mapStateToProps, { loadUserFromLocalStorage, loadNotifications, logout, clearMessage, changeLanguage })(MainContainer);

let styles = {
	mainContainer: {
		width: '100%',
		backgroundColor: '#ffffff'
	},
	logoStyle: {
		marginLeft: 27
	},
	navBarStyle: {
		backgroundColor: '#ffffff',
		boxShadow: 'rgba(153, 153, 153, 0.3) 0px 2px 8px 0px'
	},
	separator: {
		fontSize: 36,
		color: 'rgb(222, 226, 230)',
		marginRight: 10,
		fontWeight: 'lighter'
	},
	popoverLogout: {
		fontSize: 16,
		color: '#0288d1',
		float: 'right',
		cursor: 'pointer'
	},
	popoverCurrentUser: {
		fontSize: 16,
		color: '#0288d1',
		cursor: 'pointer'
	},
	alertStyle: {
		position: 'fixed',
		top: '70px',
		left: '0',
		right: '0',
		width: '400px',
		height: '50px',
		marginLeft: 'auto',
		marginRight: 'auto',
		zIndex: 1200
	},
	cursorPointer: {
		cursor: 'pointer'
	},
	notificationStyle: {
		cursor: 'pointer',
		marginTop: 14,
		marginRight: 4
	},
	currentUserSpan: {
		float: 'right',
		marginLeft: '10px'
	},
	notificationPopover: {
		width: 360
	},
	notificationsHeaderContainer: {
		backgroundColor: '#f8f8f8'
	},
	notificationsTitle: {
		fontSize: 16,
		textAlign: 'center',
		paddingTop: 5,
		paddingBottom: 5
	},
	notificationListGroup: {
		maxHeight: 420,
		overflowY: 'auto'
	},
	notificationType: {
		marginBottom: 5,
		marginRight: 2
	},
	notificationListGroupItem: {
		padding: '5px 0px 0px 12px'
	},
	restaurantName: {
		fontSize: 12,
		color: 'grey',
		marginRight: 50,
		marginBottom: 2
	},
	dateStyle: {
		fontSize: 12,
		color: 'grey',
		marginRight: 2,
		marginBottom: 2
	},
	deleteNotification: {
		cursor: 'pointer',
		float: 'right'
	},
	orderDetailsLink: {
		color: '#0288d1',
		float: 'right',
		fontSize: 14
	},
	badgeStyle: {
		position: 'absolute',
		marginLeft: 14,
		bottom: 32
	},
	dashboardDivStyle: {
		display: 'flex',
		marginRight: 20
	},
	dashboardSpanIcon: {
		marginLeft: 15,
		cursor: 'pointer'
	},
	dashboardText: {
		fontSize: 14,
		marginBottom: 0,
		cursor: 'pointer'
	},
	supportLinkStyle: {
		fontSize: 14,
		padding: '0 0 0 10px',
		marginRight: 20,
		textAlign: 'center'
	},
	supportSpanIcon: {
		marginLeft: 7
	},
	notificationNavItem: {
		marginRight: 10
	},
	profileNavItem: {
		marginTop: 9
	},
	logoSvg: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	loadingIndicator: {
        width: '72px',
        height: '72px',
    },
    loadingContainerTransparent: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
        zIndex: 100000000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}


// WEBPACK FOOTER //
// ./src/components/MainContainer.js